import styled from 'styled-components';

import StickyButton from '@/components/atom/buttons/StickyButton';
import BottomSheet from '@/components/molecules/BottomSheet';

interface Props {
  isOpened: boolean;
  onClose: () => void;
  onClickF2FGuideBottomSheet: () => void;
}

const F2FGuideBottomSheet = ({ isOpened, onClose, onClickF2FGuideBottomSheet }: Props) => {
  return (
    <BottomSheet index={10} isOpened={isOpened} onClickOverlay={onClose}>
      <Wrapper>
        <Contents>
          <Title>비대면 진료가 아닌 대면 진료예요</Title>
          <SubTitle>
            <EmphasisSubTitle>병원 방문이 필수</EmphasisSubTitle>
            이므로 예약 시 참고해 주세요.
          </SubTitle>
          <DescriptionImgWrapper>
            <DescriptionImg
              src='/images/diet_diagnosis_bottom_sheet_guide.png'
              alt='diet_diagnosis_bottom_sheet_guide'
            />
          </DescriptionImgWrapper>
        </Contents>
      </Wrapper>
      <StickyButton>
        <StickyButton.Button text={'병원 방문 예약'} onClick={onClickF2FGuideBottomSheet} />
      </StickyButton>
    </BottomSheet>
  );
};

export default F2FGuideBottomSheet;

const Wrapper = styled.div`
  padding: 12px 20px 0;
`;

const Contents = styled.div`
  margin: 0 4px;
`;

const Title = styled.div`
  display: inline-block;
  ${({ theme }) => `
    ${theme.typography.UI20SB};
    color: ${theme.color.gray800};
  `};
`;

const SubTitle = styled.div`
  margin-top: 8px;
  ${({ theme }) => `
    ${theme.typography.UI15R};
    color: ${theme.color.gray600};
  `};
`;

const EmphasisSubTitle = styled.span`
  ${({ theme }) => `
    ${theme.typography.UI15R};
    color: ${theme.color.red800};
  `};
`;

const DescriptionImgWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const DescriptionImg = styled.img`
  height: 122px;
`;
